const setTitle = (title: string) => {
  document.title = `${title} | Branding Interface`;
}

export default setTitle;